export const REGISTRATIONS_RESOURCE_PATH = '/v2/portal/registrations/entities/{{id}}';
export const USER_RESOURCE_PATH = '/v2/portal/users/entities';
export const CUSTOMER_RESOURCE_PATH = '/v2/portal/customers/entities';
export const CONTACT_RESOURCE_PATH = '/v2/portal/contacts/entities';
